import { SavedSearchRequest } from '@doda/api-client/aspida/@types';
import { apiClient } from '@doda/api-client/util/apiClient';

/**
 * 検索条件保存API
 * @param {SavedSearchRequest} request
 */
export const saveSearchConditions = (request: SavedSearchRequest) => {
  apiClient.api.v1.savedSearches.$post({ body: request });
};
